import { IWildernessAreaFWSAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory';
import { AdvisoryBlockIcon } from '../../components/icons/Icons';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties';
import { AdvisoryLink } from './AdvisoryLink';

export const WildernessAreaFWSAdvisory = (props: ICompositeAdvisoryProperties<IWildernessAreaFWSAdvisoryProperties>) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.DESNAME)));
    return (
        <SecondaryWarningAdvisory header="Wilderness Area" advisoryType={props.advisoryType} GLOBAL_ID={props.advisories[0].GLOBAL_ID} icon={AdvisoryBlockIcon} iconColor='danger'>
            <p>
                Your mission overlaps <strong>{distinctNames.join(', ')}</strong>. Check with the Fish and Wildlife Service prior to flight.
            </p>
            <p>
                The remote pilot in command must assess the local airspace along with any other takeoff, landing, and flight restrictions.
            </p>
            <p>
                <AdvisoryLink
                    text="Drones in Wilderness"
                    articleKey="DRONES_IN_WILDERNESS"
                />
            </p>
        </SecondaryWarningAdvisory>
    );
};
